import React from 'react'
import { Epub3Reader } from './epub3-reader.component'
import { QuizReader } from './quizzes-reader.component'
import ReaderHTML5 from './html5-reader.component'
import ReaderIWB from './iwb-reader.component'
import ReaderDigiIWB from './digiiwb-reader.component'
import ReaderDigiIebook from './digiiebook-reader.component'
import { ReaderDigipub } from './digipub-reader.component'
import { useReaderContext } from './context/reader-context'
import { ReaderLoader } from './reader-loader.component'
import { Scorm12Reader } from './Scorm12Reader'
export const ReaderContent = () => {
  const {
    showContent,
    readerMode: {
      IS_EPUB,
      IS_HTML5,
      IS_DIGIPUB,
      IS_DIWB,
      IS_IWB,
      IS_DIGIIWB,
      IS_SCORM,
      IS_DIGIIEBOOK,
      IS_QUIZ,
    },
  } = useReaderContext()
  // console.log('111111111111111111111', IS_QUIZ, showContent)
  return (
    <div>
      <ReaderLoader />
      {showContent ? (
        <>
          {IS_EPUB || IS_DIWB ? (
            <Epub3Reader />
          ) : IS_HTML5 ? (
            <ReaderHTML5
            // title={pkg.data?.title} url={readPackage.data?.url}
            />
          ) : IS_DIGIPUB ? (
            <ReaderDigipub />
          ) : IS_IWB ? (
            <ReaderIWB />
          ) : IS_QUIZ ? (
            <QuizReader />
          ) : IS_DIGIIWB ? (
            <ReaderDigiIWB />
          ) : IS_DIGIIEBOOK ? (
            <ReaderDigiIebook />
          ) : null}
          {IS_SCORM ? (
            // <ScormProvider
            //   version="1.2"
            //   debug={process.env.NODE_ENV !== 'production'}
            // >
            <Scorm12Reader />
          ) : null}
        </>
      ) : null}
    </div>
  )
}
